import React, { useEffect } from 'react';
import { Button } from 'antd';

import { SEOSuccessModalWrapper } from './style';
import { VERSION_TICK } from '../../config/media';

const SEOSuccessModal = ({ history, handleWidth, onCancel }) => {
    useEffect(() => {
        handleWidth(400);
    }, [handleWidth]);

    const handleRedirect = () => {
        history.push('/hosting?tab=3')
    };

    return (
        <SEOSuccessModalWrapper>
            <div className="seo-modal-container">
                <div className="seo-modal-title">
                    <img src={VERSION_TICK} alt="tick" className="verification-icon" />
                    <span className="title">Successfully saved</span>
                </div>
                <div>
                    <div className="seo-modal-content">Your settings have been saved, however to apply these to your live exchange an upgrade is required.</div>
                    <div className="seo-modal-content">Go to the 'manage' section to apply changes now or click the back button below to do it later.</div>
                </div>
                <div className="btn-container">
                    <Button
                        type="primary"
                        onClick={() => onCancel(false)}
                    >
                        Back
                    </Button>
                    <Button
                        type="primary"
                        onClick={handleRedirect}
                    >
                        Manage
                    </Button>
                </div>
            </div>
        </SEOSuccessModalWrapper>
    );
}

export default SEOSuccessModal;
